import { trackModifiedDateFieldInAuditVariable } from "./climb-web-settings";

export const buildId = process.env.BUILD_ID || 'Development Version';
export const trackModifiedDateFieldInAudit: boolean = trackModifiedDateFieldInAuditVariable;
export const debug = process.env.NODE_ENV !== 'production';

